import { Component } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DotNetDatePipe } from '../pipes/dot-net-date.pipe';
import { RootState } from '../store/root.state';
import { IApplicationContent, ApplicationOverrideInfo } from '../types';
import { AcademicYearActions } from './academic-year.actions';
import { NgxsFormDirective } from '@ngxs/form-plugin';
import { NgIf, AsyncPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-academic-year',
    templateUrl: './academic-year.component.html',
    styleUrls: ['./academic-year.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, NgxsFormDirective, ReactiveFormsModule, AsyncPipe, DatePipe, DotNetDatePipe]
})
export class AcademicYearComponent {
	content$: Observable<IApplicationContent>;

	today: Date = new Date();
	currentAcademicYearUnavailable = false;
	academicYearForm: UntypedFormGroup;
	prepNetInfo: ApplicationOverrideInfo = {};
	landingPage: string;
	showLandingPageLink: boolean = false;

	constructor(private dotNetDatePipe: DotNetDatePipe, private fb: UntypedFormBuilder, private store: Store) {
		this.createForm();
		this.buildPrepnetInfo();
		this.content$ = this.store.select(RootState.content).pipe(
			map((data) => {
				setTimeout(() => {
					this.store.dispatch(
						new AcademicYearActions.SetDefaultYear(
							this.isExternalEnroll(data.overrideNextAcademicYearEnroll),
							this.isExternalEnroll(data.overrideCurrentAcademicYearEnroll)
						)
					);
				}, 100);

				const nextOpenEnrollment: number = Date.parse(data.nextOpenEnrollmentBeginDate);
				if (nextOpenEnrollment > Date.now()) {
					this.showLandingPageLink = true;
				}
				this.landingPage = data.futureYearLandingPage;
				if (this.prepNetInfo.hasOwnProperty(data.schoolID)) {
					data.resourceStrings['nha.sa.enrolloverrideprepnet'] =
						data.resourceStrings['nha.sa.enrolloverrideprepnet'] +
						' <a href="' +
						this.prepNetInfo[data.schoolID] +
						'" target="_blank">' +
						data.resourceStrings['nha.sa.clickhere'] +
						'</a>.';
				}
				return data;
			})
		);
	}

	isExternalEnroll(override: boolean): boolean {
		const isAuthorized = window['nha-sa-authorized'];

		// disable next AY for AJB and BU
		return !isAuthorized && override;
	}

	convertToDate(date: any): Date {
		return this.dotNetDatePipe.transform(date);
	}

	createForm(): void {
		this.academicYearForm = this.fb.group({
			academicYearId: [null, [Validators.required, Validators.min(1)]]
		});
	}

	isCurrentYearUnavailable(lastDayOfSchool: string): boolean {
		if (this.today > this.convertToDate(lastDayOfSchool)) {
			return true;
		} else {
			return false;
		}
	}

	buildPrepnetInfo(): void {
		// Grand River Prep
		this.prepNetInfo['503'] = 'https://fs8.formsite.com/PrepNet/ffftj5qhdm/index.html';
		// Wellspring Prep
		this.prepNetInfo['504'] = 'https://fs8.formsite.com/PrepNet/jynjaaszqg/index.html';
		// Arbor Prep
		this.prepNetInfo['505'] = 'https://fs8.formsite.com/PrepNet/fnytlk5yxn/index.html';
		// Taylor Prep
		this.prepNetInfo['506'] = 'https://fs8.formsite.com/PrepNet/9x6h5zvgm8/index.html';
		// Canton Prep
		this.prepNetInfo['507'] = 'https://fs8.formsite.com/PrepNet/cym2aomif7/index.html';
		// Westfield Prep
		this.prepNetInfo['508'] = '';
		// Michgan Prep Virtual
		this.prepNetInfo['509'] = 'https://fs8.formsite.com/PrepNet/myd1hozusd/index.html';
	}

	getFutureLandingPageURL() {
		if (this.landingPage) {
			return this.landingPage;
		}
	}
}
